import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Property } from '../interfaces';
import { RootState } from '../store';

const initialState: {
  recentProperties: Property[];
  featuredProperties: Property[];
} = {
  recentProperties: [],
  featuredProperties: [],
}

const PropertySlice = createSlice({
  name: 'property',
  initialState,
  reducers: {
    setRecentProperties: (state, { payload }: PayloadAction<Property[]>) => {
      state.recentProperties = payload;
    },
    setFeaturedProperties: (state, { payload }: PayloadAction<Property[]>) => {
      state.featuredProperties = payload;
    },
  },
});

export const {
  setFeaturedProperties,
  setRecentProperties
} = PropertySlice.actions;

export const selectFeaturedProperties = (state: RootState): Property[] =>
  state.property.featuredProperties;

export const selectRecentProperties = (state: RootState): Property[] =>
  state.property.recentProperties;

export default PropertySlice.reducer;